'use client'
// import { Component } from "./Component"
import ReactMarquee from 'react-fast-marquee'

import { LogoMarqueeSb } from '@/components/findex-connect/types/component-types-sb'

type MarqueeProps = {
  title: string
  items: LogoMarqueeSb['logo']
}

export const Marquee: React.FC<MarqueeProps> = ({ items, title }) => {
  return (
    <div
      tabIndex={-1}
      className="MARQUEE relative flex w-[100lvw] flex-col gap-2 overflow-hidden pt-2 pb-4 md:w-full md:gap-6 md:pt-32 md:pb-20"
    >
      <h2 className="max-w-container p-gutter mx-auto w-full">{title}</h2>

      <ReactMarquee
        autoFill
        pauseOnClick
        pauseOnHover
        // no `absolute`: in the v4 source app the utility was layered and lost to
        // rfm's own `position: relative`, so the marquee rendered in flow; our
        // scoped v3 utilities would win that fight and collapse the section
        className="top-0 pb-2 md:top-2 md:pb-16"
      >
        {items?.map(({ filename, alt }, number) => (
          <div
            className={
              'MARQUEE-ITEM flex h-[164px] w-[266px] shrink-0 items-center justify-center p-2 md:p-8'
            }
            key={`${number}-${filename}`}
          >
            {/* {url ? (
              <a href={url} target="_blank"> */}
            <img src={filename!} alt={alt || `Customer Logo ${number + 1}`} />
            {/* </a>
            ) : (
              <img src={imageUrl} alt={altText} />
            )} */}
          </div>
        ))}
      </ReactMarquee>
    </div>
  )
}
